// Системні (Windows) сповіщення з desktop-додатка (Tauri). У браузері/PWA —
// no-op: там за це відповідають in-app тости, а фонові пуші — окрема тема
// (Web Push, див. docs/superpowers/specs/2026-09-17-inquiry-notifications…).

export const isDesktopApp = () => Boolean(window.__TAURI__?.core);

const MAX_SEEN = 200;

/**
 * Фабрика нотифікатора з дедупом за `key` (ringing приходить повторно по
 * кожному extension і в initial-снапшоті після реконекту SSE). invoke —
 * інʼєкція для тестів; у продакшені — window.__TAURI__.core.invoke.
 */
export function createDesktopNotifier(invoke) {
  const seen = new Set();
  return (toast) => {
    if (!toast || seen.has(toast.key)) return;
    seen.add(toast.key);
    if (seen.size > MAX_SEEN) seen.delete(seen.values().next().value);
    const { key, ...req } = toast;
    try {
      Promise.resolve(invoke('notify', { req })).catch((e) => console.warn('[desktopNotify]', e));
    } catch (e) {
      console.warn('[desktopNotify]', e);
    }
  };
}

let notifier = null;

/** Показати системне сповіщення; поза desktop-додатком — нічого не робить. */
export function desktopNotify(toast) {
  if (!isDesktopApp()) return;
  if (!notifier) notifier = createDesktopNotifier(window.__TAURI__.core.invoke);
  notifier(toast);
}

/** Бейдж на іконці (панель задач + трей) desktop-додатка; 0 — прибрати. */
export function setDesktopBadge(count) {
  if (!isDesktopApp()) return;
  try {
    Promise.resolve(window.__TAURI__.core.invoke('set_badge', { count })).catch((e) => console.warn('[desktopBadge]', e));
  } catch (e) {
    console.warn('[desktopBadge]', e);
  }
}

/**
 * Deep-link spark://open?to=/шлях (посилання з листів через /open.html):
 * забирає цільову сторінку при старті (холодний запуск) і по події
 * deep-link-open (додаток уже працює). Повертає функцію відписки.
 */
export function onDesktopDeepLink(cb) {
  if (!isDesktopApp()) return () => {};
  const { core, event } = window.__TAURI__;
  const take = () => Promise.resolve(core.invoke('take_pending_deeplink'))
    .then((target) => { if (target) cb(target); })
    .catch((e) => console.warn('[desktopDeepLink]', e));
  take();
  let unlisten = null;
  let cancelled = false;
  if (event) {
    event
      .listen('deep-link-open', take)
      .then((fn) => {
        if (cancelled) fn();
        else unlisten = fn;
      })
      .catch((e) => console.warn('[desktopDeepLink] listen', e));
  }
  return () => {
    cancelled = true;
    if (unlisten) unlisten();
  };
}

/**
 * Клік по системному сповіщенню: Rust підіймає вікно і шле подію з target.
 * Повертає функцію відписки.
 */
export function onDesktopNotificationActivated(cb) {
  const event = window.__TAURI__?.event;
  if (!event) return () => {};
  let unlisten = null;
  let cancelled = false;
  event
    .listen('desktop-notification-activated', (e) => cb(e.payload))
    .then((fn) => {
      if (cancelled) fn();
      else unlisten = fn;
    })
    .catch((e) => console.warn('[desktopNotify] listen', e));
  return () => {
    cancelled = true;
    if (unlisten) unlisten();
  };
}
